<template>
  <div>
    <!-- Toolbar: search only (no date/gender filter for procedures) -->
    <div class="flex flex-wrap items-center justify-between pb-4 py-1">
      <div class="flex items-center space-x-4">
        <div class="relative flex">
          <input
            type="text"
            v-model="filters.search_string"
            id="table-search"
            class="px-4 py-2 text-gray-700 border border-gray-300 rounded-sm dark:border-gray-300 dark:placeholder-gray-400"
            placeholder="Search"
          />
          <button
            type="submit"
            @click="applyFilters"
            class="bg-custom-yellow text-white rounded-r px-2 md:px-3 py-0 md:py-1"
          >
            <svg class="w-6 h-6 text-gray-100 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="m21 21-3.5-3.5M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"/>
            </svg>
          </button>
        </div>
      </div>
    </div>

    <!-- Stats cards -->
    <div class="mt-2">
      <div class="flex gap-3">
        <div class="w-full px-6 sm:w-1/2 xl:w-1/2 border border-gray-200 rounded-md">
          <div class="flex items-center px-1 py-3 bg-white rounded-md shadow-sm">
            <div class="w-full">
              <div class="text-gray-500">Total Patients</div>
              <h4 class="text-2xl font-semibold text-gray-700">{{ totalPatients }}</h4>
            </div>
          </div>
        </div>
        <div class="w-full px-6 sm:w-1/2 xl:w-1/2 border border-gray-200 rounded-md">
          <div class="flex items-center px-1 py-3 bg-white rounded-md shadow-sm">
            <div class="w-full">
              <div class="text-gray-500">Procedures/Services Queue</div>
              <h4 class="text-2xl font-semibold text-gray-700">{{ totalVisits }}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tabs: procedures only -->
    <div class="tabs flex border-b my-4">
      <button
        class="px-4 py-2 -mb-px font-semibold border-b-2"
        :class="currentTab === 'procedures-queue'
          ? 'border-custom-yellow text-custom-blue' : 'text-gray-500'"
        @click="currentTab = 'procedures-queue'"
      >
        Start Procedures/Services
      </button>
      <button
        class="px-4 py-2 -mb-px font-semibold border-b-2"
        :class="currentTab === 'procedures-results-queue'
          ? 'border-custom-yellow text-custom-blue' : 'text-gray-500'"
        @click="currentTab = 'procedures-results-queue'"
      >
        Continue Procedures/Services
      </button>
    </div>

    <component
      :is="currentTabComponent"
      ref="currentTabComponent"
      :filters="filters"
      @search="handleSearchStatus"
      @closeDropdown="closeDropdown"
    />
  </div>
</template>

<script>
import ConsultationProceduresQueueTab        from "../tabs/ConsultationProceduresQueueTab.vue";
import ConsultationProceduresResultsQueueTab from "../tabs/ConsultationProceduresResultsQueueTab.vue";
import apiClient from "@/services/api";

export default {
  name: "ProceduresDashboardPage",
  components: {
    ConsultationProceduresQueueTab,
    ConsultationProceduresResultsQueueTab,
  },
  data() {
    return {
      currentTab:    "procedures-queue",
      totalPatients: "loading...",
      totalVisits:   "loading...",
      filters: {
        search_string: "",
      },
      searching: false,
    };
  },
  mounted() {
    this.getProceduresDashboardData();
  },
  computed: {
    currentTabComponent() {
      switch (this.currentTab) {
        case "procedures-results-queue": return "ConsultationProceduresResultsQueueTab";
        default:                         return "ConsultationProceduresQueueTab";
      }
    },
  },
  methods: {
    applyFilters() {
      this.$refs.currentTabComponent.searchProcedures();
    },
    handleSearchStatus(event) {
      this.searching = event;
    },
    closeDropdown() {
      // No-op — kept so child tabs can emit @closeDropdown without errors
    },
    async getProceduresDashboardData() {
      try {
        const response = await apiClient.getConsultationDashboardData();
        if (response.success) {
          this.totalPatients = response.data.total_patients;
          this.totalVisits   = response.data.total_queue;
        }
      } catch (error) {
        this.$toast.error("Failed to fetch procedures data");
        console.log(error);
      }
    },
  },
};
</script>

<style lang="css" scoped></style>